export default {
  cancel: '取消',
  circle_config: '圓形調整',
  confirm: '确认',
  confirm_delete: '您確定要刪除嗎？ 這將無法撤銷。',
  create: '創建',
  delete_geometry: '刪除圖形',
  delete_vertex: '刪除頂點',
  document_upload_failed: '文檔上傳失敗。',
  draw_circle: '由中心點外沿繪製圓形',
  draw_circle_2pt: '手繪圓形',
  draw_dialog_begin_drawing: '开始绘图 - 在地图上点击任意位置',
  draw_dialog_cancel_drawing: '取消绘图 - 按 ESC 键',
  draw_dialog_remove_vertex: '移除最后一个顶点 - 右键点击',
  draw_dialog_save: '保存 - 双击',
  draw_dialog_save_single: '保存 - 单击',
  draw_dialog_title: '绘图说明',
  draw_line: '線條',
  draw_point: '點',
  draw_polygon: '多邊形',
  draw_position: '當前位置',
  draw_rectangle: '長方形',
  edit_dialog_cancel_drawing: '取消绘图 - 单击取消按钮以取消绘图。',
  edit_dialog_modify_shape:
    '编辑形状 - 拖动顶点以修改形状，或在多边形上添加新顶点。',
  edit_dialog_remove_vertex: '移除顶点 - 单击顶点以将其移除。',
  edit_dialog_save: '保存 - 单击保存按钮以保存您的更改。',
  edit_dialog_title: '编辑说明',
  filter_searchbox_placeholder: '搜索',
  icon_scaling_cluster: '聚类图标缩放',
  icon_scaling_cluster_log: '聚类对数缩放',
  icon_scaling_field: '切换字段图标缩放',
  icon_scaling_label: '图标缩放',
  icon_scaling_zoom_in: '放大缩放',
  icon_scaling_zoom_out: '缩小缩放',
  identical_values_filter: '此字段仅包含一个不同的值，无法进行过滤。',
  image_upload_failed: '圖片上傳失敗。',
  information: '信息',
  invalid_geometry: '無效圖形',
  invalid_lat_lon: '提供的坐标不在所选区域内。',
  invalid_lat_long_range: '无效的坐标：纬度和经度值必须在有效范围内。',
  layer_add_new_location: '添加新地點',
  layer_dataview_header: '顯示數據',
  layer_filter_clear_all: '清除所有篩選',
  layer_filter_dropdown_select: '選擇多個',
  layer_filter_greater_than: '大於',
  layer_filter_header: '篩選',
  layer_filter_less_than: '小於',
  layer_filter_reset_all: '重置所有过滤器',
  layer_filter_select: '從列表篩選',
  layer_filter_set_filter: '設置篩選',
  layer_grid_legend_ratio: '顏色隨圖點大小呈比例變化',
  layer_group_hide_layers: '隱藏整組圖層',
  layer_style_cluster: '多個地點',
  layer_style_display_hover: '啟用懸停',
  layer_style_display_labels: '顯示標籤',
  layer_style_header: '風格',
  layer_style_opacity: '更改图层不透明度：',
  layer_style_select_theme: '選擇主題風格',
  layer_style_switch_all: '全部切換（開關）',
  layer_style_switch_caption: '按一下標籤切換可見性',
  layer_visibility: '可見性切換',
  layer_zoom_to_extent: '縮放至篩選圖層的相應範圍',
  layers: '圖層',
  link: '關聯',
  loading: '載入中',
  location_clear_all: '清除位置點',
  location_close_without_save: '在不保存更改的情况下关闭位置？',
  location_delete: '刪除位置點',
  location_listview_full: '位置列表視圖已滿',
  location_remove: '刪除已選要素',
  location_save: '保存更改並上傳至雲端',
  location_save_changes: '保存對此位置的更改嗎？',
  location_zoom: '地圖縮放至要素邊界',
  locations: '地點',
  modify_geometry: '修改几何',
  no_data_filter: '此字段不包含数据，无法进行过滤。',
  no_layers: '在区域内没有可访问的图层。',
  no_locales:
    '您的帐户已被验证和批准，但您没有访问任何区域的权限。这可能是因为管理员没有给您所需的角色。请联系管理员以解决此问题。',
  no_options_available: '無選項',
  no_results: '未找到相關結果',
  ok: '确定',
  pill_component_remove: '移除',
  pin: '標注',
  radius: '半徑',
  remove_document_confirm: '您确定要移除此文档吗？此操作无法撤回。',
  remove_image_confirm: '您确定要移除此图片吗？此操作无法撤回。',
  remove_item_confirm: '移除项目？',
  remove_last_vertex: '刪除最後一個頂點',
  report: '報告',
  save: '保存',
  toolbar_admin: '打開帳戶管理視圖',
  toolbar_current_location: '當前位置',
  toolbar_fullscreen: '全屏地圖視圖',
  toolbar_login: '登錄',
  toolbar_logout: '登出',
  toolbar_zoom_in: '放大',
  toolbar_zoom_out: '縮小',
  toolbar_zoom_to_area: '縮放至區域',
  units: '單位',
  zoom_to: '縮放至',
};
